import "./Suport.css";
function SuportComponent() {
  return <></>;
}
export default SuportComponent;
